module.exports = __webpack_public_path__ + "static/media/talk01_small@2x.ac052bdb.jpg";